export default __webpack_public_path__ + "static/media/ms-logo.0f5de420.svg";